export default class AddonFilter {
    constructor()
    {
        this.dropdownSelector = document.getElementById('addon-dropdown-select');
        this.radioCards = document.querySelectorAll('input[name="SelectedAddonId"]');
        this.addonProducts = document.querySelectorAll('.addon-product');
        this.init();
    }

    init() {
        const dropdown = this.dropdownSelector;
        if (dropdown) {
            dropdown.addEventListener('change', (e) => {
                const selectedIndex = dropdown.selectedIndex;
                const selectedValue = dropdown.value;
                this.filterProducts(selectedValue, selectedIndex);
            });
        }

        const radios = this.radioCards;
        if (radios) {
            radios.forEach(radio => {
                radio.addEventListener('change', (e) => {
                    if (radio.checked) {
                        const selectedValue = radio.value;
                        this.filterProducts(selectedValue, null);
                    }
                });
            });
        }
    }

    filterProducts(selectedValue, selectedIndex) {
        this.addonProducts.forEach(el => {
            const matches = !selectedValue ||  selectedValue == 0 || selectedIndex === 0 || selectedValue === '' || selectedValue === '0' ||
                el.getAttribute('data-category-id') === selectedValue;
            if (matches) {
                el.classList.remove('d-none');
                el.classList.add('d-flex');
            } else {
                el.classList.remove('d-flex');
                el.classList.add('d-none');
            }
        });
    }
}
